// BLOG POST CONTENT MODEL
export const UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR_ID = 'UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR_ID';
export const UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR = 'UPDATE_POST_CONTENT_MODEL_BLOG_AUTHOR';
export const UPDATE_POST_CONTENT_MODEL_CONTENT_GROUP_ID = 'UPDATE_POST_CONTENT_MODEL_CONTENT_GROUP_ID';
export const UPDATE_POST_CONTENT_MODEL_TAG_IDS = 'UPDATE_POST_CONTENT_MODEL_TAG_IDS';
export const UPDATE_POST_CONTENT_MODEL_TITLE = 'UPDATE_POST_CONTENT_MODEL_TITLE';
export const UPDATE_POST_CONTENT_MODEL_SLUG = 'UPDATE_POST_CONTENT_MODEL_SLUG';
export const UPDATE_POST_CONTENT_MODEL_LANGUAGE = 'UPDATE_POST_CONTENT_MODEL_LANGUAGE';
export const UPDATE_POST_CONTENT_MODEL_HEAD_HTML = 'UPDATE_POST_CONTENT_MODEL_HEAD_HTML';
export const UPDATE_POST_CONTENT_MODEL_TEMPLATE = 'UPDATE_POST_CONTENT_MODEL_TEMPLATE';
export const UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES = 'UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES';
export const UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES_ENABLED = 'UPDATE_POST_CONTENT_MODEL_PUBLIC_ACCESS_RULES_ENABLED';
export const UPDATE_POST_CONTENT_MODEL_SEO_CRAWLING_ENABLED = 'UPDATE_POST_CONTENT_MODEL_SEO_CRAWLING_ENABLED';
export const UPDATE_TEXT_TO_AUDIO_FILE_ID = 'UPDATE_TEXT_TO_AUDIO_FILE_ID';

// BLOG POST SETTINGS
export const CREATE_POST_AUTHOR_FAILED = 'CREATE_POST_AUTHOR_FAILED';
export const CREATE_POST_AUTHOR_STARTED = 'CREATE_POST_AUTHOR_STARTED';
export const CREATE_POST_AUTHOR_SUCCEEDED = 'CREATE_POST_AUTHOR_SUCCEEDED';
export const CREATE_POST_TAG_FAILED = 'CREATE_POST_TAG_FAILED';
export const CREATE_POST_TAG_STARTED = 'CREATE_POST_TAG_STARTED';
export const CREATE_POST_TAG_SUCCEEDED = 'CREATE_POST_TAG_SUCCEEDED';
export const CREATE_POST_TAG_TRANSLATION_FAILED = 'CREATE_POST_TAG_TRANSLATION_FAILED';
export const CREATE_POST_TAG_TRANSLATION_STARTED = 'CREATE_POST_TAG_TRANSLATION_STARTED';
export const CREATE_POST_TAG_TRANSLATION_SUCCEEDED = 'CREATE_POST_TAG_TRANSLATION_SUCCEEDED';
export const FETCH_POST_AVAILABLE_AUTHORS_FAILED = 'FETCH_POST_AVAILABLE_AUTHORS_FAILED';
export const FETCH_POST_AVAILABLE_AUTHORS_STARTED = 'FETCH_POST_AVAILABLE_AUTHORS_STARTED';
export const FETCH_POST_AVAILABLE_AUTHORS_SUCCEEDED = 'FETCH_POST_AVAILABLE_AUTHORS_SUCCEEDED';
export const FETCH_POST_BLOGS_FAILED = 'FETCH_POST_BLOGS_FAILED';
export const FETCH_POST_BLOGS_STARTED = 'FETCH_POST_BLOGS_STARTED';
export const FETCH_POST_BLOGS_SUCCEEDED = 'FETCH_POST_BLOGS_SUCCEEDED';
export const FETCH_POST_NOTIFICATIONS_EMAILS_FAILED = 'FETCH_POST_NOTIFICATIONS_EMAILS_FAILED';
export const FETCH_POST_NOTIFICATIONS_EMAILS_STARTED = 'FETCH_POST_NOTIFICATIONS_EMAILS_STARTED';
export const FETCH_POST_NOTIFICATIONS_EMAILS_SUCCEEDED = 'FETCH_POST_NOTIFICATIONS_EMAILS_SUCCEEDED';
export const FETCH_POST_SOCIAL_ACCOUNTS_FAILED = 'FETCH_POST_SOCIAL_ACCOUNTS_FAILED';
export const FETCH_POST_SOCIAL_ACCOUNTS_STARTED = 'FETCH_POST_SOCIAL_ACCOUNTS_STARTED';
export const FETCH_POST_SOCIAL_ACCOUNTS_SUCCEEDED = 'FETCH_POST_SOCIAL_ACCOUNTS_SUCCEEDED';
export const FETCH_POST_SOCIAL_AUTO_PUBLISHING_FAILED = 'FETCH_POST_SOCIAL_AUTO_PUBLISHING_FAILED';
export const FETCH_POST_SOCIAL_AUTO_PUBLISHING_STARTED = 'FETCH_POST_SOCIAL_AUTO_PUBLISHING_STARTED';
export const FETCH_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED = 'FETCH_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED';
export const FETCH_SOCIAL_AUTO_PUBLISH_STATUS_FAILED = 'FETCH_SOCIAL_AUTO_PUBLISH_STATUS_FAILED';
export const FETCH_SOCIAL_AUTO_PUBLISH_STATUS_STARTED = 'FETCH_SOCIAL_AUTO_PUBLISH_STATUS_STARTED';
export const FETCH_SOCIAL_AUTO_PUBLISH_STATUS_SUCCEEDED = 'FETCH_SOCIAL_AUTO_PUBLISH_STATUS_SUCCEEDED';
export const FETCH_SOCIAL_BROADCASTS_FAILED = 'FETCH_SOCIAL_BROADCASTS_FAILED';
export const FETCH_SOCIAL_BROADCASTS_STARTED = 'FETCH_SOCIAL_BROADCASTS_STARTED';
export const FETCH_SOCIAL_BROADCASTS_SUCCEEDED = 'FETCH_SOCIAL_BROADCASTS_SUCCEEDED';
export const FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_FAILED = 'FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_FAILED';
export const FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_STARTED = 'FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_STARTED';
export const FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_SUCCEEDED = 'FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_SUCCEEDED';
export const FETCH_POST_TAGS_FAILED = 'FETCH_POST_TAGS_FAILED';
export const FETCH_POST_TAGS_STARTED = 'FETCH_POST_TAGS_STARTED';
export const FETCH_POST_TAGS_SUCCEEDED = 'FETCH_POST_TAGS_SUCCEEDED';
export const UPDATE_POST_SETTINGS_SHOW_ALL_ERRORS = 'UPDATE_POST_SETTINGS_SHOW_ALL_ERRORS';
export const SET_SETTINGS_SCROLL_TO = 'SET_SETTINGS_SCROLL_TO';
export const UPDATE_POST_SETTINGS_SYNC_TITLE_SLUG = 'UPDATE_POST_SETTINGS_SYNC_TITLE_SLUG';
export const UPDATE_POST_SOCIAL_AUTO_PUBLISHING_FAILED = 'UPDATE_POST_SOCIAL_AUTO_PUBLISHING_FAILED';
export const UPDATE_POST_SOCIAL_AUTO_PUBLISHING_STARTED = 'UPDATE_POST_SOCIAL_AUTO_PUBLISHING_STARTED';
export const UPDATE_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED = 'UPDATE_POST_SOCIAL_AUTO_PUBLISHING_SUCCEEDED';
export const UPDATE_POST_CREATE_AUTHOR_MODAL_OPEN = 'UPDATE_POST_CREATE_AUTHOR_MODAL_OPEN';
export const UPDATE_POST_SETTINGS_SOCIAL_AUTO_PUBLISHING_FIELD = 'UPDATE_POST_SETTINGS_SOCIAL_AUTO_PUBLISHING_FIELD';
export const UPDATE_POST_SETTINGS_CUSTOMIZE_TITLE_ENABLED = 'UPDATE_POST_SETTINGS_CUSTOMIZE_TITLE_ENABLED';

// AMP
export const UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE = 'UPDATE_ENABLE_GOOGLE_AMP_OUTPUT_OVERRIDE';
export const OPEN_SOCIAL_COMPOSER = 'OPEN_SOCIAL_COMPOSER';
export const CLOSE_SOCIAL_COMPOSER = 'CLOSE_SOCIAL_COMPOSER';

// BLOG USAGE LIMIT
export const FETCH_BLOG_LIMIT_STARTED = 'FETCH_BLOG_LIMIT_STARTED';
export const FETCH_BLOG_LIMIT_SUCCEEDED = 'FETCH_BLOG_LIMIT_SUCCEEDED';
export const FETCH_BLOG_LIMIT_FAILED = 'FETCH_BLOG_LIMIT_FAILED';
// BLOG POST USAGE LIMIT
export const FETCH_BLOG_POST_LIMIT_STARTED = 'FETCH_BLOG_POST_LIMIT_STARTED';
export const FETCH_BLOG_POST_LIMIT_SUCCEEDED = 'FETCH_BLOG_POST_LIMIT_SUCCEEDED';
export const FETCH_BLOG_POST_LIMIT_FAILED = 'FETCH_BLOG_POST_LIMIT_FAILED';
// MLANG BLOG POST USAGE LIMIT
export const FETCH_MLANG_BLOG_POST_LIMIT_STARTED = 'FETCH_MLANG_BLOG_POST_LIMIT_STARTED';
export const FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED = 'FETCH_MLANG_BLOG_POST_LIMIT_SUCCEEDED';
export const FETCH_MLANG_BLOG_POST_LIMIT_FAILED = 'FETCH_MLANG_BLOG_POST_LIMIT_FAILED';

// BLOG LISTING PAGE PAGES
export const FETCH_BLOG_LISTING_PAGES_STARTED = 'FETCH_BLOG_LISTING_PAGES_STARTED';
export const FETCH_BLOG_LISTING_PAGES_SUCCEEDED = 'FETCH_BLOG_LISTING_PAGES_SUCCEEDED';
export const FETCH_BLOG_LISTING_PAGES_FAILED = 'FETCH_BLOG_LISTING_PAGES_FAILED';

// AUDIO NARRATION
export const OPEN_AUDIO_NARRATION_PANEL = 'OPEN_AUDIO_NARRATION_PANEL';
export const CLOSE_AUDIO_NARRATION_PANEL = 'CLOSE_AUDIO_NARRATION_PANEL';
export const UPDATE_AUDIO_NARRATION_STATE = 'UPDATE_AUDIO_NARRATION_STATE';